import React, { useState } from 'react';
import "../Dashborad/dashboard.css";
import userImage from "../../Image/user.png";
import { HiOutlineBookOpen } from "react-icons/hi";
import { TbEdit } from "react-icons/tb";
import { BASE_URL } from '../../insightConfig/insightConfig';
import { useAlert } from 'react-alert';
import axios from 'axios';

function Dashboardleft({ authtoken, userDtails, setLoadUserData, loadUserData }) {
    const alert = useAlert();
    let defaultAccessCode = (Math.random() * 1000000)
    const handleFileChange = async (selectedFile) => {
        try {
            console.log("handle profile pic change", selectedFile);
            const formData = new FormData();
            formData.append('uploadedFile', selectedFile, selectedFile.name);
            const response = await axios.post(BASE_URL + '/app/uploadFile/ProfileImage', formData);
            alert.show("Image updated successfully");
            setLoadUserData(!loadUserData);
        } catch (error) {
            alert.show("Error occured while uploading profile picture");
            console.log(error);
        }


    }
    const formatExamType = (type) => {
        if (!type) return '';
        const t = type.toLowerCase();
        if (t === 'neet') return 'NEET';
        if (t === 'cuet') return 'CUET';
        if (t === 'ugc-net') return 'UGC-NET';
        if (t === 'civil services') return 'Civil Services';
        return type.toUpperCase();
    };

    return (
        <>
            <div className='dashboardleft-background'>
                <div className='dash1'>
                    <img src={userDtails.ProfileImage ? userDtails.ProfileImage : userImage} alt={userDtails.FirstName} className='dash1-img' />
                    <label for="studentImage" className=""> <TbEdit size={30} color='red' title='Upload Profile Picture' style={{ cursor: "pointer" }} /></label>
                    <input id="studentImage" style={{ display: "none" }} type="file" accept=".jpg, .jpeg, .png, .gif, .bmp, .webp, .svg, image/*"  onChange={(e) => handleFileChange(e.target.files[0])} />
                    {/* <TbEdit size={30} color='red' /> */}
                    {/* <h6>{authtoken}</h6> */}
                    <h6>{userDtails.FirstName}</h6>
                    {userDtails.ExamType && (
                        <h6 style={{ fontSize: '0.95rem', color: '#17a2b8', fontWeight: 'bold', margin: '4px 0 8px 0' }}>
                            Course: {formatExamType(userDtails.ExamType)}
                        </h6>
                    )}
                    <p><HiOutlineBookOpen className='me-2' />Code: {`${userDtails.AccessCode || Math.round(defaultAccessCode)}`}</p>
                </div>
                <div className='dash2'>
                    <div className="d-grid gap-2">
                        <button className="btn btn-subdash" type="button">SUBSCRIPTIONS</button>
                        <button className="btn btn-perdash" type="button">PERFORMANCE</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboardleft;